module.exports = __webpack_public_path__ + "img/5.70570a54.webp";